import { render, staticRenderFns } from "./VolumeSellers.vue?vue&type=template&id=45326633&scoped=true"
import script from "./VolumeSellers.vue?vue&type=script&lang=js"
export * from "./VolumeSellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45326633",
  null
  
)

export default component.exports